export default __webpack_public_path__ + "static/media/shrinkIcon.3d2a8e1f.svg";